export default "__VITE_ASSET__AKdDEOh4__"